import {Observable, Subscription} from 'rxjs';

import IVolumeStore from '../Interfaces/IVolumeStore';

const subscribeToDeactivateSlider = (
    deactivateSlider$: Observable<void>,
    volumeStore: IVolumeStore
): Subscription =>
    deactivateSlider$
        .subscribe(() => volumeStore.actions.deactivateSlider());

export default subscribeToDeactivateSlider;